




























































import Vue from 'vue';
import Component from 'vue-class-component';

const abuDhabiTrack = () => import('../assets/tracks/MF1_2019_ABUDHABI.svg');
const australiaTrack = () => import('../assets/tracks/MF1_2019_AUSTRALIA.svg');
const austriaTrack = () => import('../assets/tracks/200205__AUSTRIA.svg');
const azerbaijanTrack = () => import('../assets/tracks/MF1_2019_AZER.svg');
const bahrainTrack = () => import('../assets/tracks/MF1_2019_BAHRAIN.svg');
const belgiumTrack = () => import('../assets/tracks/MF1_2019_BELGIUM.svg');
const brazilTrack = () => import('../assets/tracks/MF1_2019_BRAZIL.svg');
const canadaTrack = () => import('../assets/tracks/MF1_2019_CANADA.svg');
const chinaTrack = () => import('../assets/tracks/MF1_2019_CHINA.svg');
const franceTrack = () => import('../assets/tracks/MF1_2019_FRANCE.svg');
const germanyTrack = () => import('../assets/tracks/MF1_2019_GERMAN.svg');
const hungaryTrack = () => import('../assets/tracks/MF1_2019_HUNGARY.svg');
const italyTrack = () => import('../assets/tracks/MF1_2019_ITALY.svg');
const japanTrack = () => import('../assets/tracks/MF1_2019_JAPAN.svg');
const mexicoTrack = () => import('../assets/tracks/MF1_2019_MEXICO.svg');
const monacoTrack = () => import('../assets/tracks/MF1_2019_MONACO.svg');
const russiaTrack = () => import('../assets/tracks/MF1_2019_RUSSIA.svg');
const saudiArabiaTrack = () => import('../assets/tracks/210121_SAUDI_ARABIA.svg');
const singaporeTrack = () => import('../assets/tracks/MF1_2019_SINGAPORE.svg');
const spainTrack = () => import('../assets/tracks/MF1_2019_SPAIN.svg');
const unitedKingdomTrack = () => import('../assets/tracks/MF1_2019_GBR.svg');
const unitedStatesTrack = () => import('../assets/tracks/MF1_2019_USA.svg');
const netherlandsTrack = () => import('../assets/tracks/MF1_2020_NETHERLANDS.svg');
const vietnamTrack = () => import('../assets/tracks/MF1_2020_VIETNAM.svg');
const italyMugelloTrack = () => import('../assets/tracks/200813_MUGELLO_16x9.svg');
const germanyNuerburgTrack = () => import('../assets/tracks/200813_NURBURGRING_16x9.svg');
const portugalTrack = () => import('../assets/tracks/200205__PORTIMAO.svg');
const sanMarinoTrack = () => import('../assets/tracks/200826_IMOLA_16x9.svg');
const turkeyTrack = () => import('../assets/tracks/200826_TURKEY_16x9.svg');
const usaMiamiTrack = () => import('../assets/tracks/220104_USA_MIAMI.svg');
const tbcTrack = () => import('../assets/tracks/TBC_track_map_asset.svg');

const RaceTrackProps = Vue.extend({
  props: {
    trackName: {
      type: String,
      required: true,
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
  },
});

@Component({
  components: {
    'race-track-abu-dhabi': abuDhabiTrack,
    'race-track-australia': australiaTrack,
    'race-track-austria': austriaTrack,
    'race-track-azerbaijan': azerbaijanTrack,
    'race-track-bahrain': bahrainTrack,
    'race-track-belgium': belgiumTrack,
    'race-track-brazil': brazilTrack,
    'race-track-canada': canadaTrack,
    'race-track-china': chinaTrack,
    'race-track-france': franceTrack,
    'race-track-germany': germanyTrack,
    'race-track-hungary': hungaryTrack,
    'race-track-italy': italyTrack,
    'race-track-japan': japanTrack,
    'race-track-mexico': mexicoTrack,
    'race-track-monaco': monacoTrack,
    'race-track-russia': russiaTrack,
    'race-track-saudi-arabia': saudiArabiaTrack,
    'race-track-singapore': singaporeTrack,
    'race-track-spain': spainTrack,
    'race-track-united-kingdom': unitedKingdomTrack,
    'race-track-united-states': unitedStatesTrack,
    'race-track-united-states-miami': usaMiamiTrack,
    'race-track-netherlands': netherlandsTrack,
    'race-track-vietnam': vietnamTrack,
    'race-track-italy-mugello': italyMugelloTrack,
    'race-track-germany-nuerburg': germanyNuerburgTrack,
    'race-track-portugal': portugalTrack,
    'race-track-san-marino': sanMarinoTrack,
    'race-track-turkey': turkeyTrack,
    'race-track-tbc': tbcTrack,
  },
})
export default class RaceTrack extends RaceTrackProps {
  sector = false;
  drs = false;
  turns = false;

  // As functional component do not emit a mounted event, using the update event was my safest bet on being informed about the mounted event.
  // Though as I'm using querySelector to detect the presence of these layers I do not want to run it more often than necessary
  svgChecked = false;
  hasDrs = true;
  hasSector = true;
  hasTurns = true;

  checkboxActiveClass (checked: boolean) {
    return {
      'f1-race-track__checkbox': true,
      'f1-race-track__checkbox--active': checked,
    };
  }

  showThisTrack (trackName: string) {
    return trackName === this.trackName;
  }

  checkFilterPresent () {
    this.svgChecked = this.$el.querySelectorAll('svg').length > 0;
    if (this.svgChecked) {
      this.hasDrs = this.$el.querySelectorAll('.drs').length > 0;
      this.hasSector = this.$el.querySelectorAll('.sectors').length > 0;
      this.hasTurns = this.$el.querySelectorAll('.turns').length > 0;
    }
  }

  updated () {
    if (this.showFilters && !this.svgChecked) {
      this.checkFilterPresent();
    }
  }

  get trackHighlightsClass () {
    return {
      'f1-race-track__image': true,
      'f1-race-track__image--show-sectors': this.sector,
      'f1-race-track__image--show-drs': this.drs,
      'f1-race-track__image--show-turns': this.turns,
      'f1-race-track__image--show-start': this.showFilters,
    };
  }
}
